class FxNewsletter extends HTMLElement {
  constructor() {
    super();
    // Initialize attributes from dataset
    this.listID = this.dataset.listId;
    this.apiURL = this.dataset.apiUrl;
    this.successMessage =
      this.dataset.messageSuccess ||
      '<p class="message-title"><strong>Thanks for subscribing!</strong></p><p class="message-description">Check your email for a confirmation message.</p>';
    this.duplicateMessage = this.dataset.messageDuplicate || '<p>You are already subscribed.</p>';
    this.errorMessage = this.dataset.messageError || '<p>There was an error. Please try again.</p>';
  }

  connectedCallback() {
    const form = this.querySelector('#klaviyo-subscription-form'); // Select the subscription form
    const messageContainer = this.querySelector('.message'); // Select the message container

    form.addEventListener('submit', (event) => {
      event.preventDefault(); // Prevent default form submission behavior

      // Collect form input values
      const email = this.querySelector('#email').value;
      const firstName = this.querySelector('#firstName').value;
      const lastName = this.querySelector('#lastName').value;

      // Prepare the form data for API submission
      const formData = new FormData();
      formData.append('g', this.listID);
      formData.append('$fields', '$email,$first_name,$last_name');
      formData.append('$email', email);
      formData.append('$first_name', firstName);
      formData.append('$last_name', lastName);

      // Hide the form and clear the message container
      form.style.display = 'none';
      messageContainer.innerHTML = '';

      // Send subscription data to the API
      fetch(this.apiURL, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Handle API response
          if (data.success && !data.data.is_subscribed) {
            messageContainer.innerHTML = this.successMessage; // Show success message
          } else if (data.data.is_subscribed) {
            messageContainer.innerHTML = this.duplicateMessage; // Show duplicate message
          } else {
            messageContainer.innerHTML = this.errorMessage; // Show error message
            form.style.display = 'block'; // Re-display the form
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          messageContainer.innerHTML = this.errorMessage; // Show error message on request failure
          form.style.display = 'block'; // Re-display the form
        });
    });
  }
}

// Define the custom element 'fx-newsletter-form'
customElements.define('fx-newsletter-form', FxNewsletter);
